// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { AbstractTableFilter, AbstractTableFilterSchema } from 'api/gen/AbstractTableFilter';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { MatchMode, MatchModeSchema } from 'api/gen/MatchMode';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { MultiSelectOperatorType, MultiSelectOperatorTypeSchema } from 'api/gen/MultiSelectOperatorType';

const requiredPart = t.interface({
  tag: t.literal('MULTISELECT_STRING'),
  field: t.string,
  matchMode: t.union([MatchModeSchema, t.null]),
  operatorType: t.union([MultiSelectOperatorTypeSchema, t.null]),
  values: t.array(t.string),
});

export const MultiSelectStringFilterSchema = excess(t.intersection([AbstractTableFilterSchema.type, requiredPart]));

export interface MultiSelectStringFilter extends t.TypeOf<typeof MultiSelectStringFilterSchema> {}
